import type { EventData } from '@/main/lib/services/Gtm/entities';

interface pianoTemplateTrackingEvent {
  eventName: string;
  type: string;
  params: {
    contentPlacement: string;
    displayMode: string;
    clickText: string;
    clickType: 'close' | 'cta button' | 'expand' | 'collapse' | 'sign in link';
  };
}

export const pianoTemplateTrackingEvent = (
  event: pianoTemplateTrackingEvent,
  sendEventOnConsent: (eventData: EventData) => void,
) => {
  switch (event.type) {
    case 'nlTemplateClick': {
      const { contentPlacement, displayMode, clickText, clickType } = event.params;

      const templateTrackingPayload = {
        eventAction: 'newsletter template clicked',
        eventLabel: 'user clicked on newsletter template',
        eventCategory: 'piano template',
        displayMode: displayMode,
        manualContentPlacement: contentPlacement,
        manualClickText: clickText,
        manualClickType: clickType,
      };

      sendEventOnConsent(templateTrackingPayload);
      break;
    }
    default:
      break;
  }
};
